import React, { useMemo } from 'react';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import Container from '@mui/material/Container';
import useGetUserData from 'hooks/useGetUserData';
import Setting from './Setting';
import SeeApiKey from './SeeAipKey';
import AccountDeactivate from './AccountDeactivate';
import data from './FormsData.json';
import AvatarSettings from './AvatarSettings';

const { FullnameFormData, EmailFormData, PasswordFormData } = data;

const UserSettings = () => {
  const { firstName, lastName, email } = useGetUserData();

  const settingsTable = useMemo(() => [
    {
      subtitleText: `${firstName || ''} ${lastName || ''}`,
      FormData: { ...FullnameFormData, formInitialState: { firstName, lastName } },

    },
    {
      subtitleText: `Your Email Address ${email} `,
      FormData: { ...EmailFormData, formInitialState: { email: '', currentEmail: email } },
    },
    {
      subtitleText: '',
      FormData: {
        ...PasswordFormData,
        formInitialState: {
          password: '',
          confirmPassword: '',
        },
      },

    },
  ], [email, firstName, lastName]);

  return (
    <Container>
      <Page withBackButton title="Account Settings">
        <AvatarSettings firstName={firstName} lastName={lastName} />
        <Paper sx={{ maxWidth: '800px' }}>
          {settingsTable
            .map(({
              titleText,
              subtitleText,
              FormData,
            }) => (
              <Setting
                titleText={titleText}
                subtitleText={subtitleText}
                FormData={{ ...FormData }}
                key={`key_${subtitleText}`}
              />
            ))}
          <SeeApiKey />
          {process.env.ACCOUNT_DEACTIVATE === 'true' && (
            <AccountDeactivate />
          )}
        </Paper>
      </Page>
    </Container>

  );
};

export default UserSettings;
